import { GetApi, PutApi } from "../../services/ApiService";

export const getDeletedUsers = async (setloading) => {
  try {
    setloading(true);
    let response = await GetApi(`/user/getDeletedUserDetails`);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return "";
  }
};

// Active User
export const activeUser = async (setloading, data) => {
  try {
    setloading(true);
    let response = [];
    response = await PutApi(`user/updateDeleteStatusActive`, data);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};
